import { Formik } from 'formik';
import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import rupees from 'app/components/VacationPlanner/assests/rupees.svg';
import info from 'app/components/VacationPlanner/assests/info.svg';
import { InvestmentPieChart } from '../PieChart';
import { useGoalPlanner } from 'app/Provider/GoalPlannerProvider';
import pic5 from 'app/components/VacationPlan/assests/Group-6.svg';

import pic1 from 'app/components/VacationPlan/assests/Vector.svg';
import pic2 from 'app/components/VacationPlan/assests/Vector-2.svg';
interface Props {
  onSubmit: (values) => void; // Changed from onsubmit to onSubmit
}

export const VacationAdvance = memo(
  forwardRef((props: Props, ref) => {
    const {
      advanceVacationData,
      setAdvancevacationamt,
      setAdvancevacationyrs,
      setAdvancevacationreturns,
      setAdvancevacationsum,
      setAdvancevacationmiscellaneousfunds,
      setAdvancevacationmiscellaneousshopping,
      setAdvancevacationmiscellaneousinsurance,
      setAdvancevacationmiscellaneoussum,
      setAdvancevacationactivitiesentertainment,
      setAdvancevacationactivitiestour,
      setAdvancevacationactivitiessum,
      setAdvancevacationfoodspecial,
      setAdvancevacationfoodmeal,
      setAdvancevacationfoodsum,
      setAdvancevacationaccommodationresort,
      setAdvancevacationaccommodationsum,
      setAdvancevacationTravellocal,
      setAdvancevacationaccommodationrrental,
      setAdvancevacationTravelticket,
      setAdvancevacationTravelsum,
      switchMode,
      setswitch,
      monthlySavings,
    } = useGoalPlanner();
    const [dropTwo, setDropTwo] = useState(false);
    const [dropThree, setDropThree] = useState(false);
    const [dropFour, setDropFour] = useState(false);
    const [dropFive, setDropFive] = useState(false);
    const [dropSix, setDropSix] = useState(false);
    const [openScenario, setOpenScenario] = useState(false);
    const [timeExtend, setTimeExtend] = useState('');
    const [returnExtend, setReturnExtend] = useState('');
    const [budgetExtend, setBudgetExtend] = useState('');
    const [inflation, setInflation] = useState('');
    const [scenarioOne, setScenarioOne] = useState(false);
    const [scenarioTwo, setScenarioTwo] = useState(false);
    const [scenarioThree, setScenarioThree] = useState(false);
    const [scenarioFour, setScenarioFour] = useState(false);
    const [drop, setDrop] = useState(false);
    const formikRef = useRef<any>(null);
    const [graphValue, setGraphValue] = useState(0);
    useEffect(() => {
      let uValue = parseFloat(advanceVacationData.amount);

      if (scenarioOne) {
        const percentage = parseFloat(inflation.replace('%', ''));
        const addvalue = (percentage / 100) * uValue;
        uValue = uValue + addvalue;
        setGraphValue(Math.round(uValue * 100) / 100);
      }

      if (scenarioFour) {
        const budgetExtValue = parseFloat(budgetExtend.substring(1));
        if (budgetExtValue > uValue) {
          setGraphValue(0);
        } else {
          setGraphValue(Math.round((uValue - budgetExtValue) * 100) / 100);
        }
      }

      if (!scenarioOne && !scenarioFour) {
        setGraphValue(
          Math.round(parseFloat(advanceVacationData.amount) * 100) / 100,
        );
      }
    }, [
      scenarioOne,
      scenarioFour,
      inflation,
      budgetExtend,
      advanceVacationData.amount,
    ]);
    // useEffect(()=>{
    //  setmetadata(metadata);
    //  if(createGoalSuccessResponse)
    //  {
    //   const payload = {
    //     id:createGoalSuccessResponse.id,
    //     metadata:metadata,
    //   }
    //   dispatch(actions.createGoal(payload));
    //  }
    // },[metadata])
    const handleInput = values => {
      const updatedvalue = {
        amount: 0,
        years: 0,
        returns: 0,
      };
      if (scenarioFour && budgetExtend !== '') {
        updatedvalue.amount =
          Number(values.amount.substring(1)) -
          Number(budgetExtend.substring(1));
        if (updatedvalue.amount < 0) {
          updatedvalue.amount = Number(values.amount.substring(1));
        }
      } else {
        updatedvalue.amount = Number(values.amount.substring(1));
      }
      if (scenarioOne && inflation !== '') {
        const percentage = Number(inflation.replace('%', ''));
        const addvalue = Number(
          ((percentage / 100) * Number(values.amount.substring(1))).toFixed(2),
        );
        updatedvalue.amount = Number(values.amount.substring(1)) + addvalue;
      }
      if (
        scenarioFour &&
        scenarioOne &&
        budgetExtend !== '' &&
        inflation !== ''
      ) {
        const percentage = Number(inflation.replace('%', ''));
        const addvalue = Number(
          ((percentage / 100) * Number(values.amount.substring(1))).toFixed(2),
        );
        updatedvalue.amount =
          Number(values.amount.substring(1)) +
          addvalue +
          Number(budgetExtend.substring(1));
        if (updatedvalue.amount < 0) {
          updatedvalue.amount = Number(values.amount.substring(1));
        }
      }
      if (scenarioTwo && timeExtend !== '') {
        updatedvalue.years = Number(timeExtend) / 12 + Number(values.years);
      } else {
        updatedvalue.years = Number(values.years);
      }
      if (scenarioThree && returnExtend !== '') {
        const numericValue = Number(returnExtend.replace('%', ''));
        updatedvalue.returns = Number(numericValue) + Number(values.returns);
      } else {
        updatedvalue.returns = Number(values.returns);
      }
      return updatedvalue;
    };
    const formatYearMonths = totalYears => {
      // Separate whole years and remaining months
      const years = Math.floor(totalYears);
      const months = Math.round((totalYears - years) * 12);
      // Construct the string
      if (years === 0) {
        return `${months} ${months !== 1 ? 'Months' : 'Month'}`;
      } else if (months === 0) {
        return `${years} ${years !== 1 ? 'Years' : 'Year'}`;
      } else {
        return `${years} ${years !== 1 ? 'Years' : 'Year'} ${months} ${
          months !== 1 ? 'Months' : 'Month'
        }`;
      }
    };
    useImperativeHandle(ref, () => ({
      submitForm: () => {
        formikRef.current?.handleSubmit();
      },
    }));
    return (
      <Formik
        innerRef={formikRef}
        initialValues={{
          amount: advanceVacationData.amount,
          years: advanceVacationData.years,
          returns: advanceVacationData.returns,
          sum1: advanceVacationData.sum1,
          sum2: advanceVacationData.travel.sum,
          tickets: advanceVacationData.travel.tickets,
          local_transportation: advanceVacationData.travel.local_transportation,
          sum3: advanceVacationData.accommodation.sum,
          resort: advanceVacationData.accommodation.resort,
          rentals: advanceVacationData.accommodation.rentals,
          sum4: advanceVacationData.food_and_beverages.sum,
          meal_budget: advanceVacationData.food_and_beverages.meal_budget,
          special: advanceVacationData.food_and_beverages.special,
          sum5: advanceVacationData.activities.sum,
          tours: advanceVacationData.activities.tours,
          entertainment: advanceVacationData.activities.entertainment,
          sum6: advanceVacationData.miscellaneous.sum,
          travel_insurance: advanceVacationData.miscellaneous.travel_insurance,
          shopping_and_souvenirs:
            advanceVacationData.miscellaneous.shopping_and_souvenirs,
          emergency_funds: advanceVacationData.miscellaneous.emergency_funds,
        }}
        onSubmit={values => {
          // e.preventDefault(); // Prevent default form submission
          props.onSubmit(values); // Basic logging
        }}
      >
        {({ values, handleChange, handleSubmit, setFieldValue }) => (
          <Div>
            <Container1>
              <CardWrapper>
                <Card className="flex-column">
                  <Title className="justify-content-between align-items-center">
                    <Text1>Advance planning mode</Text1>
                    <ToggleSwitch>
                      <ToggleInput
                        type="checkbox"
                        checked={switchMode}
                        onChange={() => setswitch()}
                      />
                      <ToggleSlider />
                    </ToggleSwitch>
                  </Title>
                  <div className="d-flex flex-column">
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText className="d-flex">Basic info |</ClickText>
                        <img src={rupees} alt="" />
                        <InputField
                          type="text"
                          name="sum1"
                          autoComplete="off"
                          placeholder="0"
                          value={values.sum1}
                          onChange={e => {
                            setFieldValue('sum1', e.target.value);
                            setAdvancevacationsum(e.target.value);
                          }}
                          flex
                        />
                      </div>
                      <Dropdown onClick={() => setDrop(drop => !drop)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    {drop && (
                      <>
                        <Input className="d-flex flex-column align-items-center mt-4">
                          <div className="d-flex justify-content-start gap-2 mt-2">
                            <Tag>VACATION BUDGET</Tag>
                            <img src={info} alt="" />
                          </div>
                          <div className="d-flex justify-content-center align-items-start mt-2 w-100">
                            {/* <img src={rupees}/> */}
                            <StyledInput
                              type="text"
                              name="amount"
                              placeholder="0"
                              autoComplete="off"
                              value={values.amount}
                              onChange={e => {
                                let inputValue = e.target.value.replace(
                                  /\D/g,
                                  '',
                                );
                                if (inputValue) {
                                  setFieldValue('amount', '₹' + inputValue);
                                  let iv = e.target.value.replace(/\D/g, '');
                                  setAdvancevacationamt(iv);
                                  setGraphValue(Number(iv));
                                } else {
                                  setFieldValue('amount', '');
                                  setGraphValue(0);
                                }
                              }}
                            />
                          </div>
                        </Input>
                        <div
                          className="d-flex  justify-content-between align-items-end"
                          style={{ marginTop: '35px' }}
                        >
                          <div className="d-flex  align-items-center justify-content-start gap-2">
                            <InfoText>When do you need the money?</InfoText>
                            <img src={info} alt="" />
                          </div>
                          <Dash className="d-flex justify-content-start gap-2">
                            <InputField
                              type="text"
                              name="years"
                              autoComplete="off"
                              placeholder="0"
                              value={values.years}
                              onChange={e => {
                                setFieldValue('years', e.target.value);
                                setAdvancevacationyrs(e.target.value);
                              }}
                              center={true}
                            />
                            <Unit className="d-flex flex-column justify-content-end">
                              yr
                            </Unit>
                          </Dash>
                        </div>
                        <Slider
                          type="range"
                          name="year"
                          value={values.years}
                          onChange={e => {
                            setFieldValue('years', e.target.value);
                            setAdvancevacationyrs(e.target.value);
                          }}
                          progress={(Number(values.years) / 100) * 100}
                          min="0"
                          max="100"
                          className="mt-3"
                        />
                        <div className="d-flex justify-content-between mt-2">
                          <Info>1 year</Info>
                          <Info>1000 years</Info>
                        </div>
                        <div className="d-flex justify-content-between align-items-end mt-5">
                          <div className="d-flex  align-items-center justify-content-start gap-2">
                            <InfoText>Expected ROI</InfoText>
                            <img src={info} alt="" />
                          </div>
                          <Dash className="d-flex justify-content-start gap-2">
                            <InputField
                              type="text"
                              name="returns"
                              autoComplete="off"
                              placeholder="0"
                              value={values.returns}
                              onChange={e => {
                                setFieldValue('returns', e.target.value);
                                setAdvancevacationreturns(e.target.value);
                              }}
                              center={true}
                            />
                            <Unit className="d-flex flex-column justify-content-end">
                              %
                            </Unit>
                          </Dash>
                        </div>
                        <Slider
                          type="range"
                          name="returns"
                          value={values.returns}
                          onChange={e => {
                            setFieldValue('returns', e.target.value);
                            setAdvancevacationreturns(e.target.value);
                          }}
                          progress={(Number(values.returns) / 100) * 100}
                          min="0"
                          max="100"
                          className="mt-3"
                        />
                        <div className="d-flex justify-content-between mt-2">
                          <Info>1%</Info>
                          <Info>100%</Info>
                        </div>
                      </>
                    )}
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText>Travel expense |</ClickText>
                        <img src={rupees} alt="" />
                        <InputField
                          type="text"
                          name="sum2"
                          autoComplete="off"
                          placeholder="0"
                          value={values.sum2}
                          onChange={e => {
                            setFieldValue('sum2', e.target.value);
                            setAdvancevacationTravelsum(
                              'travel',
                              e.target.value,
                            );
                          }}
                          flex
                        />
                      </div>
                      <Dropdown onClick={() => setDropTwo(prev => !prev)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    {dropTwo && (
                      <>
                        <div
                          className="d-flex flex-row justify-content-between w-100 gap-5"
                          style={{ marginTop: '30px' }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Ticket costs</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="tickets"
                                placeholder="0"
                                autoComplete="off"
                                value={values.tickets}
                                onChange={e => {
                                  setFieldValue('tickets', e.target.value);
                                  setAdvancevacationTravelticket(
                                    'travel',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>
                                Local Transportation costs
                              </AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="local_transportation"
                                placeholder="0"
                                autoComplete="off"
                                value={values.local_transportation}
                                onChange={e => {
                                  setFieldValue(
                                    'local_transportation',
                                    e.target.value,
                                  );
                                  setAdvancevacationTravellocal(
                                    'travel',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                        </div>
                      </>
                    )}
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText>Accommodation</ClickText>
                        <img src={rupees} alt="" />
                        <InputField
                          type="text"
                          name="sum3"
                          autoComplete="off"
                          placeholder="0"
                          value={values.sum3}
                          onChange={e => {
                            setFieldValue('sum3', e.target.value);
                            setAdvancevacationaccommodationsum(
                              'accommodation',
                              e.target.value,
                            );
                          }}
                          flex
                        />
                      </div>
                      <Dropdown onClick={() => setDropThree(prev => !prev)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    {dropThree && (
                      <>
                        <div
                          className="d-flex flex-row justify-content-between w-100 gap-5"
                          style={{ marginTop: '30px' }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Hotel/Resort costs</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="resort"
                                placeholder="0"
                                autoComplete="off"
                                value={values.resort}
                                onChange={e => {
                                  setFieldValue('resort', e.target.value);
                                  setAdvancevacationaccommodationresort(
                                    'accommodation',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>vacation rentals</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="rentals"
                                placeholder="0"
                                autoComplete="off"
                                value={values.rentals}
                                onChange={e => {
                                  setFieldValue('rentals', e.target.value);
                                  setAdvancevacationaccommodationrrental(
                                    'accommodation',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                        </div>
                      </>
                    )}
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText>Food and Beverages |</ClickText>
                        <img src={rupees} alt="" />
                        <InputField
                          type="text"
                          name="sum4"
                          autoComplete="off"
                          placeholder="0"
                          value={values.sum4}
                          onChange={e => {
                            setFieldValue('sum4', e.target.value);
                            setAdvancevacationfoodsum(
                              'food_and_beverages',
                              e.target.value,
                            );
                          }}
                          flex
                        />
                      </div>
                      <Dropdown onClick={() => setDropFour(prev => !prev)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    {dropFour && (
                      <>
                        <div
                          className="d-flex flex-row justify-content-between w-100 gap-5"
                          style={{ marginTop: '30px' }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Daily meal budget</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="meal_budget"
                                placeholder="0"
                                autoComplete="off"
                                value={values.meal_budget}
                                onChange={e => {
                                  setFieldValue('meal_budget', e.target.value);
                                  setAdvancevacationfoodmeal(
                                    'food_and_beverages',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>
                                Special dining experiences
                              </AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="special"
                                placeholder="0"
                                autoComplete="off"
                                value={values.special}
                                onChange={e => {
                                  setFieldValue('special', e.target.value);
                                  setAdvancevacationfoodspecial(
                                    'food_and_beverages',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                        </div>
                      </>
                    )}
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText>Activities |</ClickText>
                        <img src={rupees} alt="" />
                        <InputField
                          type="text"
                          name="sum5"
                          autoComplete="off"
                          placeholder="0"
                          value={values.sum5}
                          onChange={e => {
                            setFieldValue('sum5', e.target.value);
                            setAdvancevacationactivitiessum(
                              'activities',
                              e.target.value,
                            );
                          }}
                          flex
                        />
                      </div>
                      <Dropdown onClick={() => setDropFive(prev => !prev)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    {dropFive && (
                      <>
                        <div
                          className="d-flex flex-row justify-content-between w-100 gap-5"
                          style={{ marginTop: '30px' }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Tours and excursions</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="tours"
                                placeholder="0"
                                autoComplete="off"
                                value={values.tours}
                                onChange={e => {
                                  setFieldValue('tours', e.target.value);
                                  setAdvancevacationactivitiestour(
                                    'activities',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>
                                Entertainment and leisure activities
                              </AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="entertainment"
                                placeholder="0"
                                autoComplete="off"
                                value={values.entertainment}
                                onChange={e => {
                                  setFieldValue(
                                    'entertainment',
                                    e.target.value,
                                  );
                                  setAdvancevacationactivitiesentertainment(
                                    'activities',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                        </div>
                      </>
                    )}
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText>Miscellaneous |</ClickText>
                        <img src={rupees} alt="" />
                        <InputField
                          type="text"
                          name="sum6"
                          autoComplete="off"
                          placeholder="0"
                          value={values.sum6}
                          onChange={e => {
                            setFieldValue('sum6', e.target.value);
                            setAdvancevacationmiscellaneoussum(
                              'miscellaneous',
                              e.target.value,
                            );
                          }}
                          flex
                        />
                      </div>
                      <Dropdown onClick={() => setDropSix(prev => !prev)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    {dropSix && (
                      <>
                        <div
                          className="d-flex flex-row justify-content-between w-100 gap-5"
                          style={{ marginTop: '30px' }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Travel insurance</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="travel_insurance"
                                placeholder="0"
                                autoComplete="off"
                                value={values.travel_insurance}
                                onChange={e => {
                                  setFieldValue(
                                    'travel_insurance',
                                    e.target.value,
                                  );
                                  setAdvancevacationmiscellaneousinsurance(
                                    'miscellaneous',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Shopping and Souvenirs</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="shopping_and_souvenirs"
                                placeholder="0"
                                autoComplete="off"
                                value={values.shopping_and_souvenirs}
                                onChange={e => {
                                  setFieldValue(
                                    'shopping_and_souvenirs',
                                    e.target.value,
                                  );
                                  setAdvancevacationmiscellaneousshopping(
                                    'miscellaneous',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                        </div>
                        <div
                          className="d-flex flex-row justify-content-between w-100 gap-5"
                          style={{ marginTop: '30px' }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex  align-items-center justify-content-start gap-2">
                              <AdvanceText>Emergency funds</AdvanceText>
                              <img src={info} alt="" />
                            </div>
                            <AdvanceInput1 className="mt-2 align-items-center">
                              <img src={rupees} alt=""></img>
                              <AdvanceInput
                                type="text"
                                name="emergency_funds"
                                placeholder="0"
                                autoComplete="off"
                                value={values.emergency_funds}
                                onChange={e => {
                                  setFieldValue(
                                    'emergency_funds',
                                    e.target.value,
                                  );
                                  setAdvancevacationmiscellaneousfunds(
                                    'miscellaneous',
                                    e.target.value,
                                  );
                                }}
                              />
                            </AdvanceInput1>
                          </div>
                        </div>
                      </>
                    )}
                    <Click>
                      <div className="d-flex align-items-center">
                        <ClickText>Scenarios</ClickText>
                      </div>
                      <Dropdown onClick={() => setOpenScenario(prev => !prev)}>
                        <i
                          className="bi bi-chevron-down text-white"
                          style={{
                            fontSize: '12px',
                            color: '#FFFFFF',
                            fontWeight: 700,
                          }}
                        ></i>
                      </Dropdown>
                    </Click>
                    <div
                      className={`
                transition-all duration-300 ease-in-out
                ${openScenario ? 'opacity-100' : 'd-none'}
              `}
                    >
                      <Scenarios className="mt-2 justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <ScenarioText>vacation cost inflates by</ScenarioText>
                          <ScenarioQ
                            type="text"
                            placeholder="0"
                            autoComplete="off"
                            value={inflation}
                            onChange={e => {
                              let inputValue = e.target.value.replace(
                                /\D/g,
                                '',
                              );
                              if (inputValue) {
                                setInflation(inputValue + '%');
                              } else {
                                setInflation('');
                              }
                            }}
                            className="ms-1 me-1"
                          ></ScenarioQ>
                          <ScenarioText>annually</ScenarioText>
                          <img src={info} alt="" className="ms-2" />
                        </div>
                        <ToggleSwitch>
                          <ToggleInput
                            type="checkbox"
                            checked={scenarioOne}
                            onChange={() => {
                              setScenarioOne(prev => !prev);
                              // setShow(true);
                            }}
                          />
                          <ToggleSlider />
                        </ToggleSwitch>
                      </Scenarios>
                      <Scenarios className="justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <ScenarioText>Extend timeline by</ScenarioText>
                          <ScenarioQ
                            type="text"
                            placeholder="0"
                            autoComplete="off"
                            value={timeExtend}
                            onChange={e => setTimeExtend(e.target.value)}
                            className="ms-1 me-1"
                          ></ScenarioQ>
                          <ScenarioText>months</ScenarioText>
                          <img src={info} alt="" className="ms-2" />
                        </div>
                        <ToggleSwitch>
                          <ToggleInput
                            type="checkbox"
                            checked={scenarioTwo}
                            onChange={() => {
                              setScenarioTwo(prev => !prev);
                              // setShow(true);
                            }}
                          />
                          <ToggleSlider />
                        </ToggleSwitch>
                      </Scenarios>
                      <Scenarios className="justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <ScenarioText>Increase ROI by</ScenarioText>
                          <ScenarioQ
                            type="text"
                            placeholder="0"
                            autoComplete="off"
                            value={returnExtend}
                            onChange={e => {
                              let inputValue = e.target.value.replace(
                                /\D/g,
                                '',
                              );
                              if (inputValue) {
                                setReturnExtend(inputValue + '%');
                              } else {
                                setReturnExtend('');
                              }
                            }}
                            className="ms-1 me-1"
                          ></ScenarioQ>
                          <ScenarioText>
                            to achieve the target faster
                          </ScenarioText>
                          <img src={info} alt="" className="ms-2" />
                        </div>
                        <ToggleSwitch>
                          <ToggleInput
                            type="checkbox"
                            checked={scenarioThree}
                            onChange={() => {
                              setScenarioThree(prev => !prev);
                              // setShow(true);
                            }}
                          />
                          <ToggleSlider />
                        </ToggleSwitch>
                      </Scenarios>
                      <Scenarios
                        className="justify-content-between align-items-center"
                        last
                      >
                        <div className="d-flex align-items-center">
                          <ScenarioText>Reduce budget by </ScenarioText>
                          <ScenarioQ
                            type="text"
                            placeholder="0"
                            autoComplete="off"
                            value={budgetExtend}
                            onChange={e => {
                              let inputValue = e.target.value.replace(
                                /\D/g,
                                '',
                              );
                              if (inputValue) {
                                setBudgetExtend('₹' + inputValue);
                              } else {
                                setBudgetExtend('');
                              }
                            }}
                            className="ms-1 me-1"
                            budget
                          ></ScenarioQ>
                          <img src={info} alt="" className="ms-2" />
                        </div>
                        <ToggleSwitch>
                          <ToggleInput
                            type="checkbox"
                            checked={scenarioFour}
                            onChange={() => {
                              setScenarioFour(prev => !prev);
                              // setShow(true);
                            }}
                          />
                          <ToggleSlider />
                        </ToggleSwitch>
                      </Scenarios>
                    </div>
                  </div>
                </Card>
              </CardWrapper>
            </Container1>
            <Container1>
              <CardWrapper>
                <Card className="d-flex flex-column" right={true}>
                  <Text1 className="mt-2 px-4">
                    The total value of your investment after{' '}
                    {formatYearMonths(
                      Number(values.years) +
                        (scenarioTwo ? Number(timeExtend) / 12 : 0),
                    )}{' '}
                    will be
                  </Text1>
                  <Graph className="d-flex justify-content-center align-items-center mt-2">
                    {'₹' + (isNaN(graphValue) ? '0' : graphValue)}
                  </Graph>
                  <div className="d-flex flex-column align-items-center mt-5 px-5">
                    <InvestmentPieChart
                      width={400}
                      height={250}
                      values={handleInput(values)}
                    />
                  </div>

                  <div
                    style={{
                      position: 'absolute',
                      left: '0px',
                      top: '90px',
                    }}
                  >
                    <img src={pic5} alt="" className="w-32 h-32 object-cover" />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      right: '3px',
                      bottom: '3px',
                    }}
                  >
                    <img src={pic1} alt="" className="w-32 h-32 object-cover" />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      right: '50px',
                      bottom: '3px',
                    }}
                  >
                    <img src={pic2} alt="" className="w-32 h-32 object-cover" />
                  </div>

                  <div
                    className="d-flex flex-column justify-content-center align-items-center w-100 "
                    style={{
                      position: 'absolute',
                      bottom: '90px',
                    }}
                  >
                    <GraphText>
                      You need to save ₹ {monthlySavings} per month to make your
                      plan successful
                    </GraphText>
                    <Tag className="px-5">
                      But you can save ₹ {monthlySavings} per month to be on
                      safer side and make sure that plan for vacation is ON!
                    </Tag>
                  </div>
                </Card>
              </CardWrapper>
            </Container1>
          </Div>
        )}
      </Formik>
    );
  }),
);
const CardWrapper = styled.div`
  width: 100%;
  height: 100%; // Set explicit height
  display: flex;
  flex-direction: column;
`;
const GraphText = styled.h6`
  //styleName: body/b2_s-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 16px;
  font-weight: 700;
  line-height: 27.28px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #5c54ad;
`;
const Graph = styled.h6`
  //styleName: display/d3_x-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 48px;
  font-weight: 800;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Container1 = styled.div`
  width: 50%;
  height: 100vh;
  display: flex;
  position: relative;
`;
const AdvanceInput1 = styled.div`
       border: 1px solid #C8CCD8;
       border-radius:10px;
       width:100%;
       padding:0;
       height:42px;
       font-size:24px;
       padding-left:20px;
       padding-top:10px;
       padding-bottom:10px;
       display:flex;
       justify-content:between;
       background: #FFFFFF;
       }`;
const AdvanceInput = styled.input`
  border-radius: 10px;
  outline: none;
  border: none;
  width: 100%;
  padding: 0;
  //   height:42px;
  font-size: 16px;
  text-align: left;
  font-weight: 600;
  padding-left: 10px;
  background: #ffffff;
  ::placeholder {
    font-size: 16px;
    color: #838eae;
    text-align: left;
  }
`;
const StyledInput = styled.input`
  border: none;
  outline: none;
  width: 50%;
  padding: 0;
  height: 44px;
  font-size: 32px;
  text-align: center;
  background: transparent;
  ::placeholder {
    font-size: 32px;
    color: #838eae;
    text-align: center;
  }
`;

const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 45px;
  height: 22px;
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  background-color: #e4e6ec;
  border-radius: 20px;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;

  &::before {
    content: '';
    position: absolute;
    height: 16px;
    width: 16px;
    left: 1px;
    right: 1px;
    bottom: 3px;
    background-color: #4c5a81;
    border-radius: 50%;
    transition: transform 0.3s;
  }

  input:checked + & {
    background-color: #c6c0fa;
  }

  input:checked + &::before {
    transform: translateX(26px);
    background-color: #8276f4;
  }
`;
const Dropdown = styled.button.attrs({ type: 'button' })`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #8276f4;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  line-height: 0;
  overflow: hidden;
`;
const ClickText = styled.h6`
  //styleName: body/b3_reg;
  font-family: var(--fontfamilyactivefont);
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
  min-width: fit-content;
`;
const Click = styled.div`
  width: 100%;
  display: flex;
  height: 32px;
  flex-direction: row;
  margin-top: 30px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e4e6ec;
  padding-bottom: 2px;
  padding-top: 1px;
`;

const InputField = styled.input<{
  width?: string;
  center?: boolean;
  flex?: boolean;
  advance?: boolean;
}>`
  border: none;
  outline: none;
  width: ${props =>
    props.width ? '50%' : props.flex ? '45%' : props.advance ? '65px' : '43px'};
  height: 24px;
  background: #f5f6fa;
  autocomplete: off;
  text-align: ${props => (props.center ? 'right' : 'left')};
  padding-top: ${props => (props.center ? '0px' : '3px')};
  margin: 0;
  font-size: ${props => (props.center ? '24px' : '20px')};
  ::placeholder {
    text-align: ${props => (props.center ? 'right' : 'left')};
    font-size: ${props => (props.center ? '24px' : '20px')};
    color: #838eae;
  }
`;
const Info = styled.div`
  //styleName: body/b11_reg;
  font-family: var(--fontfamilyactivefont);
  font-size: 10px;
  font-weight: 400;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
const Slider = styled.input<{ progress?: number }>`
  width: 100%;
  height: 5px;
  border-radius: 18px;
  appearance: none;
  cursor: pointer;
  position: relative;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 10px;
    height: 10px;
    background: #af8eff;
    outline: 3px solid #e4dfff;
    // border: 1px solid #E4DFFF
    border-radius: 50%;
    cursor: pointer;
    margin-top: -0.05rem;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    background: ${props =>
      `linear-gradient(to right, 
             // #5C54AD 0%, 
             #AF8EFF ${props.progress}%,
             #E4DFFF ${props.progress}%, 
             #E4DFFF 100%)`};
    border-radius: 0.5rem;
  }
`;

const Unit = styled.h6`
  //styleName: body/b9_s-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Dash = styled.div<{ advance?: boolean }>`
  width: ${props => (props.advance ? '110px' : '70px')};
  border: none;
  border-bottom: 1px solid #c8ccd8;
  //   padding-left:5px;
  padding-bottom: 5px;
`;
const AdvanceText = styled.h6`
  font-family: var(--fontfamilyactivefont);
  font-size: 12px;
  font-weight: 600;
  bottom: 0;
  left: 0;
  text-align: left;
  color: #22283a;
  margin: 0;
  min-width: fit-content;
`;
const InfoText = styled.h6`
  font-family: var(--fontfamilyactivefont);
  font-size: 12px;
  font-weight: 600;
  bottom: 0;
  left: 0;
  text-align: left;
  color: #22283a;
  margin: 0;
  min-width: fit-content;
`;
const Tag = styled.h6`
  color: #22283a;
  font-family: Nunito;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.37px;
  letter-spacing: 0.1em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;

const Input = styled.div`
  margin-top: 30px; ////changes 12 to 30
  height: 90px;
  gap: 0px;
  border-radius: 15px;
  border: 1px;
  opacity: 0px;
  border: 1px solid #c6c0fa;
  background: #ffffff;
`;
const Text1 = styled.h6`
  //styleName: body/b2_s-bold;
  font-family: var(--fontfamilyactivefont);
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #22283a;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const Title = styled.div`
  display: flex;
`;
const Card = styled.div<{ right?: boolean }>`
  //////
  flex-grow: 1;
  margin-top: 28px;
  border-bottom: 1px solid #c8ccd8;
  border-right: ${props => (props.right ? 'none' : '1px solid #C8CCD8')};

  padding-right: ${props => (props.right ? '0px' : '40px')};
  padding-left: ${props => (props.right ? '0px' : '40px')};
  overflow-y: auto;
  transition: max-height 0.3s ease-in-out;
  ::-webkit-scrollbar {
    width: 0px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent; /* Color of the thumb */
    border-radius: 15px; /* Rounded corners */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #e4dfff; /* Color of thumb when hovered */
  }

  ::-webkit-scrollbar-track {
    background-color: transparent; /* Background color of the track */
    border-radius: 15px; /* Rounded corners of the track */
  }

  ::-webkit-scrollbar-corner {
    background-color: #e4dfff; /* Corner of the scrollbar */
  }
`;
const Div = styled.div`
  display: flex;
  width: 100%;
`;

const Scenarios = styled.div<{ last?: boolean }>`
  height: 60px;
  width: 100%;
  display: flex;
  border-bottom: ${props => (props.last ? 'none' : '1px solid #E4E6EC')};
`;
const ScenarioText = styled.h6`
  font-family: Nunito;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
const ScenarioQ = styled.input<{ budget?: boolean }>`
  height: 20px;
  width: ${props => (props.budget ? '50%' : '40px')};
  border: none;
  border-bottom: 1px solid #e4e6ec;
  outline: none;
  background: transparent;
  autocomplete: off;
  text-align: center;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  ::placeholder {
    text-align: center;
    font-size: 12px;
    color: #838eae;
  }
`;
